import { Styles } from 'react-jss';

export default {
  hero: {
    background: 'transparent',
  },
} as Styles;
